import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Landscape from './Components/Landscape';
import './App.css';
import PageNotFound from './Components/PageNotFound';
import { getDesktopOrMobile } from './Utils/deviceDetails';
import QrCode from './Components/QrCode';
import SmileWhite from './Components/SmileWhite';
import SmileWhiteResult from './Components/SmileWhite/Scan/result';
import Simmetry from "./Components/BearnSimmetry"
import ProtectedRoute from './Components/BearnSimmetry/protectedRoute';
import FullScan from './Components/BearnSimmetry/Scan/fullScan';
import Result from './Components/BearnSimmetry/Scan/result';
import ClaraViewFlow from './Components/ClaraView';
 const App = () => {

    const [isDesktop, setDeviceType] = useState(false)
    const [isLandscape, setLandscape] = useState(window.innerWidth > window.innerHeight)
    const handleOrientation = () => {
        detectDevice()
        setLandscape(window.innerWidth > window.innerHeight)
        document.documentElement.style.setProperty("--browser-offset", `calc(var(--vh, 1vh) * 100 - ${window.innerHeight}px)`);
    }

    const detectDevice = () => {
        const isDesktopWindows = getDesktopOrMobile()
        setDeviceType(isDesktopWindows)
    }

    useEffect(() => {
        window.addEventListener("resize", handleOrientation)
        handleOrientation()
        // window.open()
        return () => {
            window.removeEventListener("resize", handleOrientation)
        }
    }, [])


    return (
        <div className="App">
            {
                isDesktop ?
                    <Routes>
                        <Route path="/" element={<QrCode />} />
                        <Route path="/:dentalOfficeName" element={<QrCode />} />
                        <Route path="*" element={<QrCode />} />
                    </Routes> :
                    isLandscape ? <Landscape /> :
                        <Routes>
                            <Route exact path="/" element={<Simmetry />} />
                            <Route exact path="/bangkoksmile" element={<Simmetry />} />
                             <Route exact path="/smilewhitewf" element={<Simmetry />} />
                            <Route path="/smilewhite/result" element={<SmileWhiteResult />} />
                            <Route path="/smilewhite/*" element={<SmileWhite />} />
                            <Route path="/smileverse" element={<Simmetry />} />
                            {/* <Route exact path="/claraview/*" element={<ClaraViewFlow />} /> */}

                            <Route element={<ProtectedRoute />}>
                                <Route path="scan" element={<FullScan />} />
                                <Route path="result" element={<Result />} />
                            </Route>
                            <Route path="*" element={<PageNotFound />} />
                           

                        </Routes>
            }
        </div >
    );
}

export default App;